// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".layout-wrp[data-v-01569a8a]{position:relative;max-width:1920px;min-height:100%;margin:0 auto;display:flex;flex-direction:column}.layout-wrp .nuxt-child[data-v-01569a8a]{width:1920px;overflow:hidden;flex-grow:1;background:#f3f3f3}.placeholder[data-v-01569a8a]{display:block;width:100%;height:119px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
